import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

const norm = (v) => (v || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

export const ClientInput = ({ value, onChange }) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => api.get("/clients/suggest", { params: { q: value || "" } }).then((r) => setList(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [value]);
  const known = list.some((c) => norm(c.company) === norm(value));
  return (
    <>
      <Input value={value || ""} onChange={(e) => onChange(e.target.value)} list="crm-clients-list" placeholder="Ex : SCI Les Pins" autoComplete="off" data-testid="input-client" />
      <datalist id="crm-clients-list">
        {list.map((c) => <option key={c.id} value={c.company}>{c.city || ""}</option>)}
      </datalist>
      {value?.trim() && (
        <p className="text-[11px] text-muted-foreground" data-testid="client-link-hint">
          {known ? "Client existant : le projet lui sera rattaché." : "Nouveau client : il sera créé dans le CRM à l'enregistrement du projet."}
        </p>
      )}
    </>
  );
};
